export type StatusColor = 'blue' | 'red' | 'orange';

export interface OperationState {
  operationId: string;
  operationType: string;
  status: 'pending' | 'running' | 'completed' | 'failed';
  progress: number;
  message: string;
  startTime: Date;
  endTime?: Date;
}

export interface OperationErrors {
  skipped: number;
  failed: number;
  duplicates: Array<{
    email?: string;
    userId?: string;
    field: 'email' | 'userid';
    value: string;
    existingUserId: number;
  }>;
  errors: Array<{ record: any; error: string; type: 'skip' | 'fail' }>;
  showDetails: boolean;
  showDuplicateDetails: boolean;
}

export interface OperationResult {
  userId?: string;
  email?: string;
  status: 'success' | 'failed' | 'skipped';
  message: string;
  provisioning?: any;
}

export const EMPTY_OPERATION_ERRORS: OperationErrors = {
  skipped: 0,
  failed: 0,
  duplicates: [],
  errors: [],
  showDetails: false,
  showDuplicateDetails: false,
};
